<template>

  <v-layout row justify-center>
    <!--<v-btn color="primary"
           dark
           @click.stop="dialog = true">
      Open Dialog
    </v-btn>-->

    <v-dialog v-model="dialog"
              max-width="800">
      <v-card>
        <v-card-title :class="getTitleColorModal">{{$t('documents.download.additional_documents_modal_title', { 'education': item.Ime })}}</v-card-title>
        <ProgressBar :loading="loading" color="deep-purple accent-4" />

        <v-card-text v-show="greska.length > 0" class="error white--text">{{greska}}</v-card-text>

        <v-list two-line subheader dense>
          <v-list-tile v-for="item in dokumenti"
                       :key="item.Name"
                       avatar
                       @click="preuzmiFile(item)">

            <v-list-tile-content>
              <v-list-tile-title small>{{ item.Name }}</v-list-tile-title>
              <v-list-tile-sub-title>{{ item.Size }}</v-list-tile-sub-title>
            </v-list-tile-content>

            <v-list-tile-avatar>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon color="info" dark v-on="on" style="font-size: 25px !important;">info</v-icon>
                </template>
                <span>{{ $t('documents.download.tooltip') }}</span>
              </v-tooltip>
            </v-list-tile-avatar>

          </v-list-tile>
        </v-list>


        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="blue darken-1"
                 flat="flat"
                 @click="dialog = false">
            {{ $t('common.dialog_cancel_btn') }}
          </v-btn>


        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>


<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'AdditionalDocsModal',

    props: {
      storeTitleColor: ''
    },

    computed: {
      ...mapGetters('app', ['getTitleColorModal'])

    },

    data() {
      return {
        item: {},
        dialog: false,
        loading: false,
        greska: '',
        dokumenti: []
      }
    },

    methods: {
      showDialog(item) {
        this.item = item;
        this.getPopisDokumenata(item.Sifra);
        this.dialog = true;
      },

      async getPopisDokumenata(sifra) {
        this.greska = '';
        this.loading = true;

        var result = await this.$fetchDataPromise('/api/Documents/GetPopisDodatnihMaterijala', sifra)
          .catch(x => {
            this.loading = false;
            this.greska = this.__getErrorText(x);
          });

        if (typeof result !== 'undefined') {
          this.popisMaterijala = result.map(x => {
            x.icon = 'info';
            x.iconClass = 'blue lighten-1 white--text';

            if (x.Name.length > 80)
              x.Name = x.Name.substring(0, 79) + '...';

            return x;
          });
        }

        this.dokumenti = result;
        this.loading = false;
      },

      async preuzmiFile(item) {
        
        var fullPath = item.Putanja;
        this.loading = true;

        var result = await this.$fetchDataPromise('/api/Documents/DownloadDodatniDokument', fullPath)
          .catch(x => {
            this.loading = false;
            this.greska = this.__getErrorText(x);
          });

        if (typeof result != 'undefined') {
          this.$downloadByteArray([result.fileBytes], result.fileExtension, result.fileName);
          this.loading = false;
          this.$displaySuccess(this.$t('documents.download.download_success'));
        }

      }

    }
  }
</script>



// WEBPACK FOOTER //
// VueSrc/SeminarTask/components/AdditionalDocsModal.vue